import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import { LocationsService } from '../locations.service';

export const LocationResolver: ResolveFn<Location[]> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Location[]> => {
    const locationsService: LocationsService = inject(LocationsService);
    return locationsService.get(route.params['location_id']);
}
